export const PAGE_DETAILS_ROOT_URL = '/page_details';

export const ALL_PAGE_DETAILS_FETCHED = 'pageDetails/FETCHED';
